import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvSidebarItemComponent } from './nv-sidebar-item.component';

@NgModule({
  imports: [CommonModule, NvIconModule, MatRippleModule],
  declarations: [NvSidebarItemComponent],
  exports: [NvSidebarItemComponent],
})
export class NvSidebarItemModule {}
